export default __webpack_public_path__ + "static/media/background.e9e1dcae.jpg";